'use strict'

/** Utility class for computing checksums */
export class Checksum
{
  /** Computes 2-complement checksum (lower 7 bits) of
   *  the specified data.
   *  Used e.g. by Yamaha.
   */
  static twoComplement7Bit(data) {
    let sum = _.reduce(data, function(s,n){return s+n}, 0);
    sum &= 0x7f;
    let checksum = (128 - sum) & 0xf7; // low 7 bits of 2s complement
    return checksum;
  }

  /** Computes the xor (7 bits) of the specified data.
   *  Used e.g. as checksum in SDS messages.
   * @param {Uint8Array} data Data for which to compute checksum.
   * @param {number} offset Bytes prior to this are ignored. (optional)
   @ @param {number} startValue Initial value. (optional)
   */
  static xor7Bit(data, offset = 0, startValue = 0x00) {
    let value = startValue;
    for (;offset < data.length; offset++) {
      value ^= data[offset];
    }
    return value & 0x7f;
  }
}



// WEBPACK FOOTER //
// ./src/parsing_formatting/checksum.js